import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';
import React from 'react';

function DuplicateMemberSkeleton() {
  return (
    <Card>
      <CardHeader
        avatar={<Skeleton variant="circular" width={40} height={40} />}
        title={<Skeleton variant="text" width="60%" />}
        subheader={<Skeleton variant="text" width="60%" />}
      ></CardHeader>
      <CardContent>
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="60%" />
      </CardContent>
    </Card>
  );
}

export default DuplicateMemberSkeleton;
